import { useQuery } from "@tanstack/vue-query";
import { Ref } from "vue";

import { ConsumptionQueryKeys } from "@/data/api/kili/consumption/consumption-query-keys";
import { TMultisiteConsumptionRequest } from "@/data/api/kili/consumption/types/multisite-consumption.type";
import KiliApi from "@/data/api/kili/kili-api";

export function useGetMultisiteConsumptionQuery(request: Ref<TMultisiteConsumptionRequest>) {
  return useQuery({
    queryKey: ConsumptionQueryKeys.multisiteConsumption(request),
    queryFn: async () => KiliApi.getMultisiteConsumption(request.value),
    // theorically, past consumption is not meant to change
    staleTime: Infinity,
  });
}
